import { useQuery } from '@tanstack/react-query';
import { getUserOnePieceCardOwnerships } from '../services/opCardOwnershipService';
import { getUserCardOwnerships } from '../services/pokemonCardOwnershipService';
import { useAuth } from '../contexts/AuthContext';

/**
 * Hook to fetch unique sellers (purchasedFrom) from user's card collection
 * Aggregates sellers from all owned cards and returns sorted unique list
 */
export function useCardSellers() {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: ['card-sellers'],
    queryFn: async () => {
      // Fetch all ownerships (both OP and Pokemon)
      const [opOwnerships, pkmnOwnerships] = await Promise.all([
        getUserOnePieceCardOwnerships(),
        getUserCardOwnerships()
      ]);
      
      const allOwnerships = [...opOwnerships, ...pkmnOwnerships];
      
      // Extract unique sellers
      const sellers = new Set<string>();
      allOwnerships.forEach(ownership => {
        if (ownership.purchasedFrom && ownership.purchasedFrom.trim()) {
          sellers.add(ownership.purchasedFrom.trim());
        }
      });
      
      // Convert to array and sort alphabetically
      return Array.from(sellers).sort((a, b) => 
        a.localeCompare(b, undefined, { sensitivity: 'base' })
      );
    },
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
